export default __webpack_public_path__ + "static/media/undo.7172cd3e.svg";